// extracted by mini-css-extract-plugin
export default {"wrapper":"VbL46iBn0Ra1HX1TuQjz","deleteBtn":"FWFEjvPk2O2UqYHCSXvw","deleteBtnIcon":"WQ7DYs4kXC9n6yZWAma1"};